export const openDirections = (opts: { lat?: number | null; lng?: number | null; address?: string | null }) => {
  const { lat, lng, address } = opts;
  let url: string;
  if (lat != null && lng != null && !Number.isNaN(Number(lat)) && !Number.isNaN(Number(lng))) {
    url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
  } else if (address) {
    url = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;
  } else {
    return;
  }
  window.open(url, "_blank", "noopener,noreferrer");
};
